<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <!-- <h2> <strong> {{elemento}}</strong> </h2>
        <p class="mb-0" v-if="parking"> Resumen del plan <strong>{{ parkingPlan }}</strong>  en el parking
          <strong>{{ parking.name }}</strong> </p> -->


           <h5 v-if="plan" class="subtitle mb-1">{{ step }}. Resumen del {{ plan.name }}</h5>
           <p class="mb-3 text-primary">Pulsa siguiente para confirmar el pedido</p>

      </CCol>
    </CRow>


    <CCard>
      <!-- borderColor="primary" -->
      <CCardBody >
        <!-- <h5 class="subtitle mb-1">5. Resumen del plan prepago</h5>
        <p class="mb-3 text-primary">Pulsa siguiente para confirmar el pedido</p> -->

        <!-- <CForm @submit.prevent data-vv-scope="new-delivery"> -->

          <CRow>
            <CCol sm="12">

              <CCard body-wrapper>

                <!-- <div class="d-flex justify-content-between align-items-center mb-4">
                  <span>
                    <strong>Pedido: # {{ getPayment(productItem.payments) }}</strong>
                  </span>

                  <span v-if="!isActive(productItem.status)">
                    <a @click="downInvoice"
                    :class="{'text-primary': !isActive(productItem.status) }"
                    >Descargar Factura  <i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>
                  </span>
                </div> -->

                <!-- <div class="d-flex justify-content-start align-items-end my-4">
                  <CIcon name="cil-calendar" height="56" class="text-secondary" />
                  <div class="ml-2">
                    <p class="mb-0">Fecha de inicio: {{ stringUtils.dateTimeFormat(productItem.entry_event.datetime) }}</p>
                    <p class="mb-0">Fecha de fin: {{ stringUtils.dateTimeFormat(productItem.exit_event.datetime) }}</p>
                  </div>
                </div> -->


                <div class="d-flex justify-content-start align-items-start my-4 info-my-rents">

                  <div class="mr-3">
                    <CIcon name="cil-calendar" height="56" class="text-secondary" />
                  </div>

                  <div>


                      <p class="title-product mb-1">{{ productItem.plan.name }}</p>

                      <p class="mb-0">Del {{ product.start_datetime | DateSimple }} al {{ product.end_datetime | DateSimple }}</p>


                      <p>
                      {{ plan.plan_detail.duration }} días de duración. El plan está activo desde las {{ plan.plan_detail.start_hour }} h del {{ product.start_datetime | DateSimple }} hasta las {{ plan.plan_detail.end_hour }} h del
                      {{product.end_datetime | DateSimple}}

                      </p>

                      <p class="mb-0" >Del <span>{{ product.start_datetime | DateSimple }} a las {{ plan.plan_detail.start_hour }} </span></p>

                      <p class="mb-0">Al <span>{{ product.end_datetime | DateDMY }} a las  {{ plan.plan_detail.end_hour  }} </span>  </p>

                  </div>


                    <CRow>
                      <CCol sm="12">

                        <strong class="mb-1">Duración: </strong>

                        <!-- <p v-if="product && product.longitude_value">{{ Number(product.longitude_value / 1000).toFixed(1)}} Km </p> -->
                        <!-- <p v-if="product">{{ parkingPlan.plan.duration }} </p> -->


                      </CCol>

                      <CCol sm="12">

                        <CCardGroup deck>

                          <CCard>
                            <CCardHeader color="gradient-primary" class="text-white">
                              {{'Inicio'.toUpperCase()}}</CCardHeader>
                            <CCardBody>
                             {{ product.start_datetime | DateSimple }}
                            </CCardBody>
                          </CCard>

                          <CCard>
                            <CCardHeader color="gradient-dark" class="text-white" >Fin</CCardHeader>
                            <CCardBody>

                              {{ product.end_datetime | DateSimple }}
                            </CCardBody>
                          </CCard>
                        </CCardGroup>
                      </CCol>

                      <CCol sm="12" class="mt-3">
                        La facturación del estacionamiento, una vez finalice el PLAN se realizará por precio por minuto, min una hora
                      </CCol>



                      <!-- <CCol sm="4" class="d-flex justify-content-end align-items-end">
                        <p v-if="product" style="font-weight: 600; font-size: 1rem;" >
                          {{ product.amount ? product.amount : 0 | toFixedNoRounding }} €
                        </p>
                      </CCol> -->

                    </CRow>





                </div>


                <div class="d-flex justify-content-between align-items-center my-4 info-my-rents">

                  <div>
                    <strong>{{ productItem.parking.name }}</strong>
                    <p>{{ productItem.parking.address }}</p>
                  </div>



                  <div class="text-right">
                    <span>Total: </span>
                    <strong> {{ productItem.amount }} € </strong>
                    <p class="mt-0 text-black-50"> (IVA incluido)</p>
                  </div>
                </div>



                <div class="d-flex justify-content-between align-items-center">

                  <!-- <CButton @click="gotToDetail"  color="outline-dark" shape="pill" class="px-4">Detalle</CButton> -->


                    <!-- <CSwitch class="mx-1"
                      color="primary"
                      variant="3d"
                      shape="square"
                      :checked="productItem.renewal ? productItem.renewal : false"
                      v-bind="labelIcon"
                      :value="productItem"
                      :disabled="productItem.status == 'FINISHED'"

                      @update:checked="() => $emit('toggle-renewal', productItem)"
                    /> -->


                  <!-- <span :class="`text-${getStatusColor(productItem.status)}`">
                    {{stringUtils.getLabelStatus(productItem.status)}}</span> -->

                </div>

                </CCard>


            </CCol>

          </CRow>


        <!-- </CForm> -->

        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>

       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>

    <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="saveDelivery" class="btn-login-custom btn" >
        <!-- Siguiente -->
        Proceder al pago
      </button>
    </div>

    <spinner-ttt :show="loading"></spinner-ttt>


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
// import apiTools from "@/app/shared/utils/apiTools"
import { CALENDAR_LANG } from "@/config";

import { createDelivery, getProductStore, setProductStore } from "@/app/shared/global/services/product-service";

// import { fetchOneParking } from "@/app/shared/global/services/parking-service";
// detalle del plan seleccionado

export default {
  name: "DetallePlanResumen",
  components: {

  },
  props: {
    plan: { type: Object, default() {return {}}, required: true },
    parkingPlan: { type: Object, default() {return {}},required: true },
  },
  data() {
    return {
      step: 2,
      elemento: "Resumen del Plan",
      loading: true,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        hours:[],
      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      errorPlan: false,

      parkings: [],
      planes: [],
      parking: null,

    };
  },
  created() {

  },
  async mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      await this.setDataLocalStorage();
    }

  },

  computed: {

    productItem: function () {
      return {...this.parkingPlan}
    },
  },

  methods: {

    saveDelivery() {

      // this.$validator.validateAll('new-delivery').then( async (valid) => {

      //   if (valid ) {

          this.loading = true;
          const errorMessage = `Se ha producido un error`;

          try {

            // const contractToSave = {
            //  ...this.product
            // }
            // this.contractPlanApi = {...contractToSave};

            this.nextStep();

          } catch (e) {
            console.log(e);
            this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');

          } finally {
            this.loading = false;
          }

      //   } else {
      //     this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
      //   }
      // })

    },

    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        if (storedData) {

          this.product = {
            ...storedData,
          };

        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    saveDataLocalStorage() {
      setProductStore(this.product);
    },


    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      const data = { valid: true, parkingId: this.product.parkings_id, plandId:  this.product.plans_id  }
      this.$emit("validForm", data);
      this.loading = false;



    },



    formatDataSelect(ad) {

      if (ad) {
        const label = ad.store ? `${ad.alias} - ${ad.address}` : ad.address

        return {
          label: label, //`${ad.alias} - ${ad.address}`,
          value: ad.id
        }
      }
    },






  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
